<div class="panel-gap">
  <div style="display: flex; align-items: center; gap: 8px">
    @if (layer.props.description) {
      <div class="layer-description-text">
        {{ layer.props.description }}
      </div>
    }
    @if(layer.props?.enableAiInteraction && (isAiAssistantEnabled$ | async)){
      <div>
        <button
          matSuffix
          mat-icon-button
          color="primary"
          class="icon button"
        style="
          background-color: #1976d2;
          border-radius: 50%;
          color: #fff;
          width: 28px;
          height: 28px;
          min-width: 28px;
          min-height: 28px;
          padding: 0;
        "
          (click)="onAiAssistantClicked()"
          >
          <span class="material-symbols-outlined" style="font-size: 16px"
            >auto_awesome</span
            >
          </button>
        </div>
      }
    </div>
  </div>
